import React, { useEffect } from "react";
import { createPortal } from "react-dom";

import "./SuccessOverlay.css";

const SuccessOverlay = ({
  show = false,
  countdown = 5,
  title = "Payment Successful! 🎉",
  description = "Your payment has been successfully processed.",
  countdownDuration = 5,
}) => {
  // ============================================================
  // DISABLE BACKGROUND SCROLLING
  // ============================================================

  useEffect(() => {
    if (!show) return;

    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [show]);

  if (!show) return null;

  const progress =
    countdownDuration > 0
      ? Math.max(0, Math.min(100, (countdown / countdownDuration) * 100))
      : 0;

  return createPortal(
    <div className='checkout-success-overlay' role='presentation'>
      <div
        className='checkout-success-modal'
        role='dialog'
        aria-modal='true'
        aria-labelledby='checkout-success-title'
        aria-describedby='checkout-success-description'
      >
        {/* ================================================== */}
        {/* SUCCESS ICON */}
        {/* ================================================== */}

        <div className='checkout-success-icon-wrapper'>
          <div className='checkout-success-icon'>
            <span aria-hidden='true'>✓</span>
          </div>
        </div>

        {/* ================================================== */}
        {/* SUCCESS CONTENT */}
        {/* ================================================== */}

        <div className='checkout-success-content'>
          <h2 id='checkout-success-title' className='checkout-success-title'>
            {title}
          </h2>

          <p
            id='checkout-success-description'
            className='checkout-success-description'
            aria-live='polite'
          >
            {description}
            <br />
            You will be redirected automatically in <strong>
              {countdown}
            </strong>{" "}
            {countdown === 1 ? "second" : "seconds"}.
          </p>

          {/* ================================================== */}
          {/* COUNTDOWN PROGRESS */}
          {/* ================================================== */}

          <div className='checkout-success-progress'>
            <div
              className='checkout-success-progress-bar'
              style={{
                width: `${progress}%`,
              }}
            />
          </div>

          <div className='checkout-success-footer'>
            Please do not close or refresh this page.
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SuccessOverlay;
